import React, { Component } from 'react';
import { connect } from "react-redux";
import SearchSelectList from '../SearchSelectList';
import SearchSelectListItem from '../SearchSelectListItem';
import { getServiceRequests } from '../../../actions/userActions';
import Highlighter from 'react-highlight-words';


function mapStateToProps (store) {
    return { api: store.api };
}

function mapDispatchToProps (dispatch, ownProps) {
    return {
        getServiceRequests: (filterQuery, size, from) =>
            dispatch(getServiceRequests({ filterQuery, size, from }))
    };
}

class ServiceRequestSearchSelectList extends Component {

    constructor (props) {
        super(props);

        this.renderItem = this.renderItem.bind(this);
        this.onFetch = this.onFetch.bind(this);
    }

    _wrap (highlightTokens, text) {
        return (
            <Highlighter
                highlightClassName="searchHighlight"
                searchWords={highlightTokens}
                textToHighlight={text}
                autoEscape={true}
            />
        );
    }

    onFetch (filterQuery, extraFilter, size, from) {
        return this.props.getServiceRequests(filterQuery, size, from);
    }

    renderItem (serviceRequest, props, searchValue) {
        const highlightTokens = searchValue.toLowerCase()
            .split(/\s+/)
            .filter((s) => s);

        return (
            <SearchSelectListItem
                item={serviceRequest}
                key={serviceRequest.srNumber}
                rowClassName="serviceRequestListItem"
                selectText="Select Service Request"
                onSelectItem={this.props.onSelectItem}
                mainColSize={8}
            >
                <div>SR #<strong>{this._wrap(highlightTokens, serviceRequest.srNumber)}</strong></div>
                <div>{this._wrap(highlightTokens, serviceRequest.siteName)}</div>
                <div>
                    <small>
                        {this._wrap(highlightTokens, serviceRequest.siteCity)}
                        {', '}
                        {this._wrap(highlightTokens, serviceRequest.siteRegion)}
                    </small>
                </div>
            </SearchSelectListItem>
        );
    }

    render () {
        return (
            <SearchSelectList
                title="Select Your Service Request"
                searchPlaceholder="Search to find a service request"
                onFetch={this.onFetch}
                showStaticList={false}
                showFilter={false}
                renderItem={this.props.renderItem ? this.props.renderItem : this.renderItem}
                {...this.props}
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ServiceRequestSearchSelectList);



// WEBPACK FOOTER //
// ./app/components/SelectLists/Types/ServiceRequestSearchSelectList.jsx